/** @format */

export enum TagDistributionValue {
	CON = 'con',
	PRO = 'pro'
}

export enum FilterType {
	FEATURE = 'feature',
	RATING = 'rating',
	SORT = 'sort',
	STANDARD = 'standard',
	TAG = 'tag'
}
